import { createFileRoute } from '@tanstack/react-router';
import { PaymentDetailPage } from '@/modules/payments/pages/PaymentDetailPage';

export const Route = createFileRoute('/dashboard/payments/$id/')({
  component: PaymentDetailPageRoute,
});

function PaymentDetailPageRoute() {
  const { id } = Route.useParams();
  return <PaymentDetailPage id={id} />;
}
